// 对冲金额流程
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="mini" @click="$router.go(-1)">返回</el-button>
      <span>金额对冲申请</span>
    </div>
    <!-- end of title -->

    <!-- start of form -->
    <div class="form-box">
      <!-- start of 金额对冲说明 -->
      <div class="back-color-fff mt-4">
        <span class="form-title">金额对冲说明</span>
        <el-form :model="formData" :rules="formRules" label-width="140px" ref="formData">
          <el-row :gutter="24">
             <el-col :span="6">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">是否转包任务：</span>
                <el-select
                  class="fl"
                  v-model="formData.isChangeService"
                  placeholder="请选择"
                  filterable
                  @change="changeService"
                >
                  <el-option v-for="item in getCodeListByKey('是否')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="relevance">
                <span slot="label"> <span style="color: red">*</span>关联流程： </span>
                <el-input
                  style="width: 380px"
                  v-model="formData.relevance"
                  placeholder="请选择关联流程"
                  readonly
                  @focus="focusRelevance"
                >
                </el-input>
                <span v-if="formData.relevance" class="file-preview" @click="seeDetail">查看详情</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item prop="isRepay">
                <span slot="label"> <span style="color: red">*</span>是否已付款： </span>
                <el-select style="width: 220px" v-model="formData.isPaid" placeholder="请选择" @change="onChangeIsPaid">
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.isPaid === 'Y'">
              <el-form-item label-width="160px">
                <span slot="label"> <span style="color: red">*</span>累计已付款金额(元)： </span>
                <el-input
                  disabled
                  style="width: 150px"
                  type="text"
                  maxlength="12"
                  v-model="formData.paidAmount"
                  @blur="amountBlur($event.target.value,'paidAmount')"
                />
                <!-- onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" -->
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.isPaid === 'Y'">
              <el-form-item label-width="160px">
                <span slot="label"> <span style="color: red">*</span>累计已退回金额(元)： </span>
                <el-input
                  disabled
                  style="width: 150px"
                  type="text"
                  maxlength="12"
                  v-model="formData.returnedAmount"
                  @blur="amountBlur($event.target.value,'returnedAmount')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="formData.isPaid === 'Y'">
            <el-col :span="8">
              <el-form-item label-width="140px">
                <span slot="label">
                    退款日期：
                </span>
                <el-date-picker
                  :picker-options="pickerOptions"
                  v-model="formData.returnedDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择退款日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem">
                <span slot="label"> <span style="color: red">*</span>对冲说明： </span>
                <el-input
                  style="width: 380px"
                  v-model.trim="formData.memo"
                  placeholder="请输入"
                  clearable
                  maxlength="200"
                  :rows="3"
                  resize="none"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- end of 付款申请信息 -->

      <!-- start of 退款明细 -->
      <div class="back-color-fff mt-4" v-show="formData.isPaid == 'Y'">
        <div class="form-title-box">
          <span class="form-title">退款明细</span>
        </div>
        <el-button class="ml16 w110" 
          type="primary" 
          size="mini"
          @click="addRefundDialog"
        >
          新增
        </el-button>
         <div class="content-main-box mt12" style="height: auto;">
          <el-table
            class="ml16"
            style="width: 90%"
            :data="refundDetail"
            stripe
            border
            highlight-current-row
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              width="200"
              prop="payBankName"
              label="付款方银行"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.payBankName || '-'  }}
              </template>
            </el-table-column>
            <el-table-column
              prop="payBankAccount"
              label="付款方银行账户"
            >
              <template slot-scope="scope">
                {{ scope.row.payBankAccount || '-'  }}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="payAmount"
              label="已付款金额(元)"
              align="center"
            >
              <template slot-scope="scope">
                <div class="t-right">
                  {{ scope.row.payAmount | numFmt | numDigit  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="refundAmount"
              label="已退回金额(元)"
              align="center"
            >
              <template slot-scope="scope">
                <div class="t-right">
                  {{ scope.row.refundAmount | numFmt | numDigit  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="backAmount"
              label="本次退款金额(元)"
              align="center"
            >
              <template slot-scope="scope">
                <el-input
                  class="t-right"
                  style="width: 90%"
                  v-model="scope.row.backAmount"
                  type="text"
                  placeholder="0.00"
                  @blur="validateCurrentRefundAmount($event.target.value, scope.$index)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="deleteRefundItem(scope.$index)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- end of 退款明细 -->

      <!-- start of 流程审批 -->
      <div class="back-color-fff mt-4">
        <!-- <span class="form-title">流程审批</span> -->
        <div class="flow">
          <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
        </div>
      </div>
      <!-- end of 流程审批 -->

      <!-- start of bottom-btn -->
      <div class="back-color-fff submit_btn_wrap">
        <el-button type="defalut" class="cannel-btn" size="mini" @click="$router.go(-1)">取消</el-button>
        <el-button type="defalut" v-if="this.$route.query.type != 2" size="mini" @click="saveForm()">保存</el-button>
        <el-button type="primary" size="mini" @click="submitForm()">{{
          this.$route.query.type == 2 ? '重新提交' : '提交申请'
        }}</el-button>
      </div>
      <!-- end of bottom-btn -->
    </div>
    <!-- end of form -->

    <!-- start of dialog-关联流程 -->
    <el-dialog :title="'关联流程'" class="flow-dialog" :visible.sync="dialogFormVisible" width="80%">
      <div class="content-main-box content-main-box2">
        <div class="search-area">
          <el-row :gutter="24">
            <el-col :span="8" v-if="formData.isChangeService == 'Y'">
              <div class="search-area-div w80">
                <span style="color: red">*</span>
                流程名称
              </div>
              <el-select
                filterable
                clearable
                v-model="page.flowName"
                placeholder="请选择流程名称"
                size="mini"
                class="ipt-sty"
              >
                <el-option label="对账单流程" value="Y"></el-option>
                <el-option label="付款流程" value="N"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <div class="search-area-div w80">关键字搜索</div>
              <el-input
                v-model="page.searchKey"
                placeholder="请输入企业、组织、应付金额搜索"
                size="mini"
                class="ipt-sty"
              >
              </el-input>
            </el-col>
            <!-- <el-col :span="8">
                            <div class="search-area-div w60">关联状态</div>
                            <el-select v-model="page.isSettleHedgeUsed" placeholder="请选择关联状态" size="mini" class="ipt-sty">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已关联" value="Y"></el-option>
                                <el-option label="未关联" value="N"></el-option>
                            </el-select>
                        </el-col> -->
            <el-col :span="8" class="search-btn-box">
              <el-button size="mini" type="info" @click="searchFlowList">搜索</el-button>
              <el-button size="mini" type="danger" @click="empty">清空</el-button>
            </el-col>
          </el-row>
        </div>

        <el-table
          :header-cell-class-name="cellClass"
          stripe
          border
          ref="multipleTable1"
          highlight-current-row
          :height="tableHeight"
          :data="flowLists"
          :row-key="(row) => row.guid"
          :current-row-key="currentRowKey"
          @row-click="flowListsChange"
          @select="handleSelectFlow"
        >
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <!-- selection -->
          <!-- <el-table-column  :reserve-selection="true" type="selection" width="60" header-align="center" align="center"
                        fixed="left"></el-table-column> -->
          <!-- 流程名称 -->
           <el-table-column
            prop="flowNo"
            label="流程编号"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">{{ scope.row?.approveVO?.flowNo || '-' }}</template>
          </el-table-column>
          <el-table-column prop="flowName" label="流程名称" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{
              scope.row.approveVO && scope.row.approveVO.flowName ? scope.row.approveVO.flowName : '-'
            }}</template>
          </el-table-column>
          <!-- 发起人 -->
          <el-table-column
            prop="applyStaffName"
            width="96"
            label="发起人"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.applyStaffName || '-' }}
            </template>
          </el-table-column>
          <!-- 企业名称 -->
          <el-table-column prop="tenantName" label="企业名称" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.operationReportTenantName || '-' }}
            </template>
          </el-table-column>
          <!-- 组织名称 -->
          <el-table-column
            prop="organisationName"
            label="组织名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.organisationName || '-' }}
            </template>
          </el-table-column>
          <!-- 核算月 -->
          <el-table-column prop="accountMonth" label="核算月" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.newAccountMonth || '-' }}
            </template>
          </el-table-column>
          <!-- 任务包名称 -->
          <el-table-column
            prop="taskTitleName"
            label="任务包名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.operationReportTaskTitle ? JSON.parse(scope.row.operationReportTaskTitle).join('、') : '-'
            }}</template>
          </el-table-column>
          <!-- 应付金额 -->
          <el-table-column
            prop="payable"
            label="应付金额(元)"
            header-align="center"
            align="right"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.payable | numFmt | numDigit }}</template>
          </el-table-column>
        </el-table>

        <!-- start of pagination -->
        <!-- <el-pagination
                    class="pt pb back-color-fff"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="page.pageIndex"
                    :page-size="page.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.totalRows"
                >
                </el-pagination> -->
        <!-- end of pagination -->
      </div>
      <div slot="footer">
        <el-button plain size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="info" @click="selectProcess()">确定</el-button>
      </div>
    </el-dialog>
    <!-- end of dialog-关联流程 -->
    <ChoosePerson ref="choosePerson" staffType="1" @onSelect="onPersonSelect"></ChoosePerson>

    <!-- Payment Records Dialog Component -->
    <PaymentRecordsDialog
      ref="paymentRecordsDialog"
      :refundDetail="refundDetail"
      :orderType="orderType"
      :currentRowRelevance="currentRow"
      :detailData="detailData"
      @select="handleRefundSelect"
    />
    <!-- end of Payment Records Dialog -->
  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
import { Decimal } from 'decimal.js';

import store from '@/store';
import ChoosePerson from './components/choosePersonOne';
import PaymentRecordsDialog from './components/PaymentRecordsDialog';
import { OrderTypeEnum } from './enum';
export default {
  components: {
    ChoosePerson,
    PaymentRecordsDialog,
  },
  data() {
    let userInfo = JSON.parse(localStorage.userInfo);
    return {
      userInfo,
      fullscreenLoading: false,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      guid: '',
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() >= Date.now();
        // },
      },
      formData: {
        isChangeService: 'N',
        memo: '',
        relevance: '', // 关联流程
        payTime: '', // 结算时间
        isInvoiced: '', // 是否已开票
        payBankAccount: '',
        payBankName: '',
        receiveBankAccount: '',
        receiveBankName: '',
        upstreamInvoiceItem: [],
        isRepay: '',
        paymentAttaches: [],
        payAmount: null,
      },

      formRules: {},
      detailData: {},
      refundDetail: [],
      orderType: OrderTypeEnum.SETTLEMENT,
      tableData: [
        {
          key: 1,
          taskContent: '结算金额(元)',
          settleAmount: 'settleAmount',
          memo: '个人结算明细表',
        },
        {
          key: 2,
          taskContent: '结算人数(个)',
          settleAmount: 'personNum',
          memo: '详见结算明细表',
        },
        {
          key: 3,
          taskContent: '服务费(元)',
          settleAmount: 'serviceAmount',
          memo: '服务费费率',
        },
        {
          key: 4,
          taskContent: '结算总额(元)',
          settleAmount: 'totalAmount',
          memo: '结算金额+服务费金额',
        },
      ],

      // 关联流程相关
      dialogFormVisible: false,
      page: {
        pageIndex: 1,
        pageSize: -1,
        staffGuid: userInfo.staffGuid,
        listType: 0, // 0全部 1我发起的 2我审批的 3抄送我的 4待我审批的
        serviceTenantGuid: localStorage.guid,
        flowTypeList: ['00021'], // 00021:结算单流程,00022:付款单流程
        isSettleHedgeUsed: 'N',
        flowName: 'N',
      },
      flowLists: [],
      tableHeight: '37.5vh',
      // 流程图相关
      iframeSh: false,
      iframeSrc: '',

      currentRow: '',
      currentRowKey: '',

      payBankList: [],
      receiveBankList: [],
      reciveList: [],
      fileSize: serverConfig.FILE_SIZE,
      personShow: false,
    };
  },
  watch:{
    'formData.isPaid':{
      handler(val) {
        if (val === 'N') {
          // this.formData.returnedDate = ''
          // this.formData.returnedAmount = ''
          // this.formData.paidAmount = ''
          this.$set(this.formData,'returnedDate','')
          this.$set(this.formData,'returnedAmount','')
          this.$set(this.formData,'paidAmount','')
          
        }
      }
    }
  },
  created() {
    if (this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      this.getDetail();
    } else {
      this.getApprovalList();
    }
  },
  methods: {
    onChangeIsPaid() {
      if (this.formData.isPaid === 'Y') {
        this.setPaidAmountAndReturnedAmount();
      } else {
         this.formData.paidAmount = ''
         this.formData.returnedAmount = ''
      }
    },
    changeService() {
      this.formData.relevance = '';
      this.formData.payAmount = '';
      this.refundDetail = [];
      this.detailData = {};
    },
    /**
     * 搜索关联流程
     */
    searchFlowList() {
      this.$refs.multipleTable1?.clearSelection();
      this.currentRowKey = '';
      this.currentRow = {};
      if(this.formData.isChangeService == 'Y') {
        this.getStatementList();
        return
      }
      this.getFlowList(true);
    },
    amountBlur(value,str, index){
      let regex = /[^\d\.]/g;
      value = value.replace(regex, '');
      if(value.indexOf('.')>-1){//保留两位小数
        value = value.toString().substring(0, value.indexOf('.') + 3);
      }
     
      this.formData[str]=value;
    },
    validateCurrentRefundAmount(value, index) {
      // 保留两位小数
      if(value.indexOf('.')>-1){//保留两位小数
        value = value.toString().substring(0, value.indexOf('.') + 3);
      }

      const item = this.refundDetail[index];
      if(item.payAmount == item.refundAmount){
        this.$message.error(`${item.payBankName || '该银行'}已全退款，不能继续退款`);
        this.$set(this.refundDetail[index], 'backAmount', '');
        return
      }
      const backAmount = new Decimal(value || 0);
      const payAmount = new Decimal(item.payAmount || 0);
      const refundAmount = new Decimal(item.refundAmount || 0);
      const availableAmount = payAmount.minus(refundAmount);
      
      if (backAmount.greaterThan(availableAmount)) {
        const  maxAmount = payAmount.minus(refundAmount).toString();
        this.$message.error(`${item.payBankName || '该银行'}本次退款金额需 <= ${maxAmount}`);
      }
      this.$set(this.refundDetail[index], 'backAmount', value);
      this.setPaidAmountAndReturnedAmount();
      
    },
    addRefundDialog() {
      this.$refs.paymentRecordsDialog.open();
    },
    setPaidAmountAndReturnedAmount() {
      const paidAmount = this.refundDetail
        .reduce(
          (acc, item) => acc.plus(new Decimal(item.payAmount || 0)),
          new Decimal(0)
        )
        .toString();
      const returnedAmount = this.refundDetail
        .reduce(
          (acc, item) => acc.plus(new Decimal(item.backAmount || 0)).plus(new Decimal(item.refundAmount || 0)),
          new Decimal(0)
        )
        .toString();
      this.formData = {
        ...this.formData,
        paidAmount,
        returnedAmount,
      };
    },
    handleRefundSelect(selectedRows) {
      const newItems = selectedRows.map(item => {
        return {
          ...item,
          invoiceGuid: item.guid,
          payAmount: item.receiveAmount || 0,
        };
      });
      
      const existingGuids = new Set(this.refundDetail.map(item => item.guid));
      const uniqueNewItems = newItems.filter(item => !existingGuids.has(item.guid));
      
      this.refundDetail = [...this.refundDetail, ...uniqueNewItems];
      this.refundDialogVisible = false;
      this.setPaidAmountAndReturnedAmount();
    },
    deleteRefundItem(index) {
      this.refundDetail.splice(index, 1);
      this.setPaidAmountAndReturnedAmount();
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disabledCheck';
      }
    },

    focusRelevance() {
      this.dialogFormVisible = true;
      this.searchFlowList();
    },
    /**
     * 保存
     */
    saveForm() {
      if (!this.checkForm()) return;
      this.postFormData(false);
    },
    /**
     * 提交
     */
    submitForm() {
      if (!this.checkForm()) return;
      if (this.personShow && !this.formData.startAssigner) {
        this.$refs.choosePerson.visible = true;
        return;
      }
      this.postFormData(true);
    },
    checkForm() {
      if (!this.formData.relevance) {
        this.$message.error('关联流程不能为空');
        return false;
      }
      if (!this.formData.isPaid) {
        this.$message.error('是否已付款不能为空');
        return false;
      }
      if (this.formData.isPaid === 'Y' && !this.formData.paidAmount) {
        this.$message.error('已付款金额不能为空');
        return false;
      }
      if (this.formData.isPaid === 'Y' && !this.formData.returnedAmount) {
        this.$message.error('已退回金额不能为空');
        return false;
      }
      if (!this.formData.memo) {
        this.$message.error('对冲说明不能为空');
        return false;
      }
      // if ((!this.formData.upstreamInvoiceItem || !this.formData.upstreamInvoiceItem.length) && this.formData.isRepay == 'Y') {
      //     this.$message.error('关联上游收款不能为空')
      //     return false;
      // }
      const f = this.refundDetail.some(item => !item.backAmount)
      if(f){
        this.$message.error('本次退款金额不能为空');
        return false;
      }

      // 校验本次退款金额是否大于可用金额（已付款金额 - 已退回金额）
      for (const item of this.refundDetail) {
        const backAmount = new Decimal(item.backAmount || 0);
        const payAmount = new Decimal(item.payAmount || 0);
        const refundAmount = new Decimal(item.refundAmount || 0);
        const availableAmount = payAmount.minus(refundAmount);
        
        if (backAmount.greaterThan(availableAmount)) {
          const maxAmount = availableAmount.toString();
          this.$message.error(`${item.payBankName || '该银行'}本次退款金额需 <= ${maxAmount}`);
          return false;
        }
      }

      return true;
    },
    postFormData(flag) {
      let self = this;
      let { userInfo } = this;
      let postData = JSON.parse(JSON.stringify(this.formData));
      postData['settleGuid'] = this.detailData.guid;
      postData['serviceTenantGuid'] = this.detailData.serviceTenantGuid || null;
      postData['serviceTenantName'] = this.detailData.serviceTenantName || null;
      postData['tenantGuid'] = this.detailData.tenantGuid || null;
      postData['tenantName'] = this.detailData.tenantName || null;
      postData['applyStaffGuid'] = userInfo.staffGuid || null;
      postData['applyStaffName'] = userInfo.staffName || null;
      postData['immediateSubmit'] = flag; // false是保存 true是保存
      postData.refundDetailJson = JSON.stringify(this.refundDetail);
      postData.serviceTenantGuid = this.detailData.tenantGuid || null;
      postData.serviceTenantName = this.detailData.tenantName || null;
      postData.tenantGuid = this.detailData.tenantGuid || null;
      postData.tenantName = this.detailData.serviceTenantName || null;
      if (this.$route.query.guid) {
        postData['serviceTenantGuid'] = postData.serviceTenantGuid || null;
        postData['serviceTenantName'] = postData.tenantName || null;
        postData['tenantGuid'] = postData.tenantGuid || null;
        postData['tenantName'] = postData.tenantName || null;
        // postData['payAmount'] = postData.payAmount || null;
        postData['guid'] = this.$route.query.guid;
        postData['guidResubmit'] = this.$route.query.type == 2 ? this.$route.query.guid : null;
        this.fullscreenLoading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/hedge/update`, postData)
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (flag) {
                self.$message.success('提交成功！');
              } else {
                self.$message.success('保存成功！');
              }
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      } else {
        this.fullscreenLoading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/hedge/add`, postData)
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (flag) {
                self.$message.success('提交成功！');
              } else {
                self.$message.success('保存成功！');
              }
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      }
    },
    /**
     * 选择流程
     */
    selectProcess() {
      let { currentRow } = this;
      if (!currentRow['guid']) return this.$message.error('请关联流程');
      // 关联流程后显示发起人 + 代征公司简称 + 月份 + 费用总金额
      // this.formData.relevance =
      //   currentRow['applyStaffName'] +
      //   ' _ ' +
      //   currentRow['tenantName'] +
      //   ' _ ' +
      //   currentRow['newAccountMonth'] +
      //   (currentRow['totalAmount'] ? ' _ ' + this.formatMoney(currentRow['totalAmount']) + '(元)' : '');
      this.formData.payAmount = currentRow['payable'];
      this.formData.upstreamInvoiceItem = [];
      this.getDetailData();
      this.dialogFormVisible = false;
    },
    /**
     * 获取下游结算单详情
     */
    getDetailData(data) {
      let self = this;
      let guid = data?.settleGuid || this.currentRow.guid;
      let url = `/downstream/payment/detail` // 付款单
      this.orderType = OrderTypeEnum.PAYMENT;
      if (this.currentRow.billType == 3 || data?.billType == 3) {
        // 对账单
        url = `/downstream/statement/detail`
        this.orderType = OrderTypeEnum.RECONCILIATION;
      }
      if (this.formData.isChangeService == 'N') {
        // 原有逻辑
        url = `/downstream/settle/detail`
        this.orderType = OrderTypeEnum.SETTLEMENT;
      }
      this.$set(this.formData, 'relevance', '');
      self.api.get(`/${serverConfig.msSalesPerformService}${url}/${guid}`).then((res) => {
        let { code, data, msg } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(!data){
            return;
          }
          self.detailData = data;
          let accountMonth = data.accountMonth ? JSON.parse(data.accountMonth) : [];
          // 显示发起人 + 药企简称 + 月份 + 应付金额
          let relevance =
            data['applyStaffName'] +
            ' _ ' +
            data['tenantName'] +
            (accountMonth.length > 0 ? ' _ ' + accountMonth.join(' , ') : '') + // 核算月有可能没有
            (data['payable'] ? ' _ ' + this.formatMoney(data['payable']) + '(元)' : '');
          this.$set(this.formData, 'relevance', relevance);
          this.getApprovalList();
        } else {
          self.detailData = {};
          self.$message.error(msg);
        }
      });
    },
    //获取对冲流程详情
    getDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/downstream/settle/hedge/detail/${self.$route.query.guid}`)
        .then((res) => {
          let { code, data, msg } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.formData = data;
            // let accountMonth = data.accountMonth ? JSON.parse(data.accountMonth) : [];
            // // 显示发起人 + 药企简称 + 月份 + 应付金额
            // this.formData['relevance'] =
            //   data['applyStaffName'] +
            //   ' + ' +
            //   data['tenantName'] +
            //   ' + ' +
            //   accountMonth.join(' , ') +
            //   (data['totalAmount'] ? ' + ' + this.formatMoney(data['totalAmount']) + '(元)' : '');
            if (this.formData['paymentAttaches'] && this.formData['paymentAttaches'].length) {
              this.formData['paymentAttaches'].forEach((item) => {
                item.name = item.fileName;
              });
            }
            this.refundDetail = data.refundDetailJson ? JSON.parse(data.refundDetailJson) : [];


            this.getDetailData(data);
          } else {
            self.$message.error(msg);
          }
        });
    },
    /**
     * 获取付/收款银行
     */
    getBankList(tenantGuid, type) {
      let self = this;
      if (type == 1) {
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=${tenantGuid}`)
          .then((res) => {
            let { code, data, msg } = res.data;
            if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.payBankList = data.bankList;
              if (this.$route.query.guid) {
                self.payBankList.forEach((item) => {
                  if (item.bankName == this.formData.payBankName && item.bankAccount == this.formData.payBankAccount) {
                    this.formData.payBankName = item.guid;
                  }
                });
              }
            } else {
              self.$message.error(msg);
            }
          });
      }
      if (type == 2) {
        let query = {
          serviceTenantGuid: localStorage.guid,
          tenantGuid: tenantGuid,
        };
        this.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-banks-by-rel`, query).then((res) => {
          let { code, data, msg } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.receiveBankList = data[0].bankList;
            if (this.$route.query.guid) {
              self.receiveBankList.forEach((item) => {
                if (
                  item.bankName == this.formData.receiveBankName &&
                  item.bankAccount == this.formData.receiveBankAccount
                ) {
                  this.formData.receiveBankName = item.guid;
                }
              });
            }
          } else {
            self.$message.error(msg);
          }
        });
      }
    },
    payBankNameChange(val) {
      this.payBankList.forEach((item) => {
        if (val == item.guid) {
          this.formData.payBankAccount = item.bankAccount;
        }
      });
      console.log(val);
    },
    reciveBankNameChange(val) {
      this.receiveBankList.forEach((item) => {
        if (val == item.guid) {
          this.formData.receiveBankAccount = item.bankAccount;
        }
      });
      console.log(val);
    },
    // 关联流程-对账单
    async getStatementList() {
      const params = {
        serviceTenantGuid: localStorage.guid,
        accountMonth: this.page.accountMonth,
        searchKey: this.page.searchKey,
        billTypeList: [3], // [1,3]查对账单+结算单
        approveStateList: ['Y'],
      }
      // 付款单时 查询条件
      if (this.page.flowName == "N") {
        params.billTypeList = [2];
        params.approveStateList = ['R','C'];
        params.isChangeService = "Y";
        params.isOnlyPay = "Y";
      }
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/statement/list`,
        params
      );
      this.fullscreenLoading = false;

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      let list = data.data || [];
      this.flowLists = list.map(item => {
        let newAccountMonth = JSON.parse(item.accountMonth) || [];
        newAccountMonth = newAccountMonth?.join(',') || '';
        return {
          ...item,
          newAccountMonth: newAccountMonth || '',
        }
      });
    },
    /**
     * 获取关联流程列表数据
     */
    getFlowList(flag = false) {
      if (flag) {
        this.page.pageIndex = 1;
        this.flowLists = [];
      }
      let self = this;
      let postData = {
        ...this.page,
        approveState: 'Y',
        listType: 1,
      };
      this.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/page-list`, postData).then((res) => {
        this.fullscreenLoading = false;
        let { code, msg, data } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = data ? data.records : [];
          list.forEach((item) => {
            let accountMonth = JSON.parse(item.accountMonth) || [];
            item.newAccountMonth = accountMonth.join(',');
          });
          self.flowLists = list;
        } else {
          self.$message.error(msg);
        }
      });
    },
    /**
     * 修改当前页的数量
     * @param {*} val
     */
    handleSizeChange(val) {
      this.page.pageSize = val;
      if(this.formData.isChangeService == 'Y') {
        this.getStatementList();
        return
      }
      this.getFlowList();
    },
    /**
     * 修改分页
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.page.pageIndex = val || 1;
      if(this.formData.isChangeService == 'Y') {
        this.getStatementList();
        return
      }
      this.getFlowList();
    },
    /**
     * 关联流程，查看详情
     */
    see() {},
    /**
     * 勾选关联流程数据
     */
    flowListsChange(row) {
      this.$refs.multipleTable1.clearSelection();
      row.flag = !row.flag;
      this.$refs.multipleTable1.toggleRowSelection(row, row.flag);
      this.currentRowKey = row.guid;
      this.currentRow = row;
    },
    handleSelectFlow(selection, row) {
      this.$refs.multipleTable1.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.currentRow = row;
        this.currentRowKey = row.guid;
        this.$refs.multipleTable1.toggleRowSelection(row, true);
      }
    },
    /**
     * 清空条件搜索,重新获取流程列表数据
     */
    empty() {
      const userInfo = JSON.parse(localStorage.userInfo);
      this.page = {
        pageIndex: 1,
        pageSize: -1,
        staffGuid: userInfo.staffGuid,
        listType: 0, // 0全部 1我发起的 2我审批的 3抄送我的 4待我审批的
        serviceTenantGuid: localStorage.guid,
        flowTypeList: ['00021'], // 00021:结算单流程,00022:付款单流程
        isSettleHedgeUsed: 'N',
        flowName: 'N',
      };
      if(this.formData.isChangeService == 'Y') {
        this.getStatementList();
        return
      }
      this.getFlowList();
    },
    /**
     * 获取流程列表
     */
    async getApprovalList() {
      const userInfo = JSON.parse(localStorage.userInfo);
      const { approveVO } = this.formData;
      if (this.guid && approveVO.camundaInstanceId && approveVO.camundaDeploymentId) {
        this.iframeSrc = `${bpmnroute}/iframeBpmn?processInstanceId=${approveVO.camundaInstanceId}&camundaDeploymentId=${approveVO.camundaDeploymentId}&token=${localStorage.token}`;
        this.isLastPerson(approveVO.camundaDeploymentId);
        this.iframeSh = true;
        this.$forceUpdate()
      } else {
        try {
          const req = {
            tenantGuid: localStorage.guid,
            flowType: '00025',
            staffGuid: userInfo.staffGuid,
          };
          const res = await this.api.postJson(
            `/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`,
            req,
          );
          if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              this.isLastPerson(res.data.data);
              this.iframeSrc = `${bpmnroute}/iframeBpmn?camundaDeploymentId=${res.data.data}&token=${localStorage.token}`;
              this.iframeSh = true;
              this.$forceUpdate()
            } else {
              this.$message.error('未获取到流程信息');
            }
          } else {
            this.$message.error(res.data.msg);
          }
        } catch (error) {
          this.$message.error('请求出错');
        }
      }
    },

    /**
     * 数字金额转大写
     * @param {*} num
     */
    convertToChinese(num) {
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const decimals = ['角', '分'];
      const cnIntRadice = ['', '拾', '佰', '仟'];
      const cnIntUnits = ['', '万', '亿', '兆'];

      let cnNum = '';
      let isNegative = false;

      if (num < 0) {
        isNegative = true;
        num = Math.abs(num);
      }

      let parts = String(num).split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1];

      if (Number(integerPart) === 0) {
        cnNum = digits[0];
        return cnNum;
      }

      let intLen = integerPart.length;
      let zeroCount = 0;

      for (let i = 0; i < intLen; i++) {
        let n = parseInt(integerPart.charAt(i));
        let p = intLen - i - 1;
        let q = p / 4;
        let m = p % 4;

        if (n === 0) {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            cnNum += digits[0];
          }
          zeroCount = 0;
          cnNum += digits[n] + cnIntRadice[m];
        }

        if (m === 0 && zeroCount < 4) {
          cnNum += cnIntUnits[q];
        }
      }

      if (decimalPart) {
        let decLen = decimalPart.length;
        for (let i = 0; i < decLen; i++) {
          let n = parseInt(decimalPart.charAt(i));
          if (n !== 0) {
            cnNum += digits[n] + decimals[i];
          }
        }
      }

      if (isNegative) {
        cnNum = '负' + cnNum;
      }

      return cnNum;
    },
    /** 导入**************************************** */
    onPreview(file) {
      var fileSuffix;
      if (file.name) {
        fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      }
      if (file.fileName) {
        fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      }

      if (
        fileSuffix === 'png' ||
        fileSuffix === 'jpeg' ||
        fileSuffix === 'jpg' ||
        fileSuffix === 'pdf' ||
        fileSuffix === 'zip' ||
        fileSuffix === 'rar'
      ) {
        return window.open(file.path);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    // 上传文件
    changeMainFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < serverConfig.FILE_SIZE;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${serverConfig.FILE_SIZE}MB`);
        this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.formData.paymentAttaches.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            console.log(this.paymentAttaches);
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleMainRemove(file) {
      this.formData.paymentAttaches.forEach((item, index) => {
        if (item.path == file.path) {
          this.formData.paymentAttaches.splice(index, 1);
        }
      });
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    isLastPerson(camundaDeploymentId) {
      let self = this;
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/nodes/is-need-design?deploymentId=${camundaDeploymentId}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.personShow = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //指定人
    onPersonSelect([personGuid, data]) {
      this.formData.startAssigner = personGuid.join(',');
      if (!this.formData.startAssigner) {
        this.$message.error('请先选择人员!');
        return;
      }
      this.postFormData(true);
    },
    seeDetail() {
      let url = '/settlementDocDetail'
      if(this.formData.isChangeService == 'Y' && this.currentRow.billType == 3){
        // 对账单
        url = '/settlementBillDetail'
      }
      if (this.formData.isChangeService == 'Y' && this.currentRow.billType != 3) {
        // 付款单
        url = '/downstreamPaymentDetail'
      }
      url += '?guid=' + this.detailData.guid;
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: '';
  text-align: center;
  line-height: 37px;
}

.file-operate {
  display: flex;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}

.content {
  padding: 0px;
  margin: 0px;

  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;

    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }

    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .mt-4 {
    margin-top: 4px;
  }

  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
      font-weight: 500;
    }

    /deep/ .el-row {
      margin: 0px !important;
    }

    .el-form-item {
      margin-bottom: 8px;
    }

    .over-label /deep/ .el-form-item__label {
      line-height: 21px;
    }

    .el-input {
      width: 220px;
    }

    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;

      .el-button--primary {
        color: #ffffff;
      }
    }
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }

  .flow {
    background: #fff;
    padding-left: 20px;
  }

  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }

  .detail-box {
    height: auto;
    border: 1px solid rgba(217, 217, 217, 1);
    margin: 0px 16px;
    padding: 16px 16px 100px 16px;
  }

  .cannel-btn {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #212121;
  }

  .content-main-box2 {
    height: 55vh;
    overflow-x: hidden;

    .search-area {
      padding: 16px 0px;
    }

    .el-table {
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
    }
  }

  .file-img-box {
    display: flex;
    align-items: center;

    img {
      width: 26px;
      height: 26px;
      margin-right: 10px;
    }

    .see-btn {
      font-size: 14px;
      color: #4fa1a4;
      letter-spacing: 0;
      line-height: 21px;
      font-weight: 400;
      cursor: pointer;
      margin-left: 10px;
    }
  }

  .flex-between,
  .form-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form-title-box {
    padding-right: 16px;
  }

  h2 {
    text-align: center;
  }

  .txt-right {
    text-align: right;

    span {
      margin: 0px 16px;
    }
  }

  .table1 {
    border: 1px solid rgba(217, 217, 217, 1);

    .header-div {
      background: #f2f2f2;
      font-size: 12px;
      color: #909399;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      height: 32px;
      line-height: 32px;
      font-weight: 500;
    }

    .tab-label {
      padding: 0px 10px;
      width: 200px;
      height: 32px;
      color: #212121;
      line-height: 32px;
      background: #fafafa;
      border-top: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-value {
      text-align: right;
      padding: 0px 10px;
      width: calc(100% - 200px);
      height: 32px;
      line-height: 32px;
      border-top: 1px solid rgba(229, 229, 229, 1);
      color: #666666;
    }

    p {
      color: #666666;
    }

    .line-box {
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      padding-left: 10px;

      div:first-child {
        width: 80px;
        background: #fafafa;
        // border-top: 1px solid rgba(229, 229, 229, 1);
        border-right: 1px solid rgba(229, 229, 229, 1);
        font-weight: bold;
      }

      div:last-child {
        padding: 10px 6px;
        width: calc(100% - 80px);

        // border-top: 1px solid rgba(229, 229, 229, 1);
      }
    }
  }

  .table2,
  .table3 {
    border-left: 1px solid rgba(217, 217, 217, 1);
    border-right: 1px solid rgba(217, 217, 217, 1);
    border-bottom: 1px solid rgba(217, 217, 217, 1);
  }

  .table2 {
    margin: 16px 0px;
  }

  .info-box {
    width: calc(50% - 12px);
  }
}
.search-area .el-col-8{
    justify-content: flex-start;
}
</style>
